import Immutable from "immutable";
import { storage } from "services/storage";

const NoticeRecord = Immutable.Record({
  isVisible: true
});

const initialState = Immutable.Map({
  "zendesk_chat": new NoticeRecord({
  }),
  "authentication": new NoticeRecord({
  })
});
const storedState = Immutable.fromJS(storage.retrieve("notices"));
const mergedState = storedState ? initialState.mergeDeep(storedState) : initialState;

export const notices = (state = mergedState, action) => {
  switch (action.type) {
    case "SHOW_NOTICE":
      return state.set(action.name, new NoticeRecord({
        isVisible: true
      }));
    case "DISMISS_NOTICE":
      return state.setIn([action.name, "isVisible"], false);
    default:
      return state;
  }
};
